export const developmentHostnames = [ 'localhost' ]
export const stageHostnames = [
  /**
   * Устаревшая схема стэйдж-доменов.
   * Оставлена только для обратной совместимости и будет удалена в одном из следующих релизов.
   * Актуальные стэйдж-домены находятся на sigmasms-stage.ru.
   */
  /^(?:[a-z0-9-]+\.)?stage-online\.sigmasms\.ru$/,
  /**
   * Временный стенд задачи получает префикс через дефис, а не через точку:
   * online-767-online.sigmasms-stage.ru.
   */
  /^(?:[a-z0-9-]+[.-])?online\.sigmasms-stage\.ru$/
]
export const productionHostnames = [
  'online.sigmasms.ru',
  'online.mirsms.ru',
  'online.freesender.net',
  'online.apisender.com'
]
export const jivositeRoistatHostnames = [ 'online.sigmasms.ru' ]
export const hostnames = [
  ...developmentHostnames,
  ...stageHostnames,
  ...productionHostnames
]

export const imlinkHostnames = [
  'online.imlink.io',
  'stage-online-l4nipwn7.sigmasms.ru'
]
